import 'core-js/es6';
import 'core-js/fn/promise';
import 'core-js/es7/reflect';
import 'core-js/client/shim.min';
import '../libs/etc/es6-shim.min.js';
import '../libs/etc/system-polyfills.js';
require('zone.js/dist/zone');
import '../libs/etc/shims_for_IE.js';
import 'web-animations-js/web-animations.min';
//import 'reflect-metadata/Reflect.js';

if (process.env.ENV && process.env.ENV.trim() === 'production' || process.env.ENV && process.env.ENV.trim() === 'iproduction') {
    // Production
} else {
    // Development and test
    Error['stackTraceLimit'] = Infinity;
    require('zone.js/dist/long-stack-trace-zone');
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/polyfills.ts